// extracted by mini-css-extract-plugin
export var chip = "_3q-0";
export var filterDropdown = "_3q-5";
export var filterItem = "_3q-6";
export var icon = "_3q-1";
export var removeButton = "_3q-3";
export var removeIcon = "_3q-4";
export var separator = "_3q-2";